import { render, staticRenderFns } from "./treatmentpartadjust.vue?vue&type=template&id=2cf0bf0c&scoped=true"
import script from "./treatmentpartadjust.vue?vue&type=script&lang=js"
export * from "./treatmentpartadjust.vue?vue&type=script&lang=js"
import style0 from "./treatmentpartadjust.vue?vue&type=style&index=0&id=2cf0bf0c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf0bf0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cf0bf0c')) {
      api.createRecord('2cf0bf0c', component.options)
    } else {
      api.reload('2cf0bf0c', component.options)
    }
    module.hot.accept("./treatmentpartadjust.vue?vue&type=template&id=2cf0bf0c&scoped=true", function () {
      api.rerender('2cf0bf0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sale/treatmentpartadjust.vue"
export default component.exports